import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { GoGrabber } from "react-icons/go";
import { IoIosCheckmark } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import noDataFound from "../../../../components/assets/No data-rafiki 1.svg";
import high from "../../../../components/assets/high_priority.svg";
import low from "../../../../components/assets/low_priority.svg";
import normal from "../../../../components/assets/normal_priority.svg";
import { getRequest, patchRequest } from "../../../../components/axiosClient";
import { errorNotification } from "../../../../components/toast-notification/common-toast";
import {
  GET_TASKS,
  UPDATE_PROJECT_TASKS_INDEX,
  UPDATE_TASK,
} from "../../../../components/utils";
import deleteIcon from "../../../../components/assets/bin.svg";
import { Box, ClickAwayListener, Drawer, Popover } from "@mui/material";
import { SlOptions } from "react-icons/sl";
import secureLocalStorage from "react-secure-storage";
import AddTaskListRow from "./AddTaskListRow";
import DrawerTaskDetail from "../../../../components/Drawer/DrawerTaskDetail";

const TaskListView = ({
  projectId,
  handleTaskView,
  handleTaskComplete,
  deleteStatus,
  taskList,
  getTasks,
  columnTitles,
  setColumnTitles,
  handleAddNewTitle,
  handleTitleChange,
  memberList,
  boardView,
}) => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState();
  const [newTitle, setNewTitle] = useState("");
  const [addingTaskToColumn, setAddingTaskToColumn] = useState(null);
  // const [taskList, setTaskList] = useState([]);
  const navigate = useNavigate();
  const rowRef = useRef();
  const [statusDeleteId, setStatusDeleteId] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);

  const drawerWidth = "40%";

  const role_access =
    JSON.parse(secureLocalStorage.getItem("role_accesses")).find(
      (access) => access.module.name === "Projects"
    )?.access_type !== "Read";

  useEffect(() => {
    getTaskList();
  }, [taskList, columnTitles]);

  const handleDrawerOpen = (taskId, projectId) => {
    setOpen(true);
    setSelectedTaskId(taskId);
    // navigate(`/task-details/${id}`);
  };

  // const fetchTasks = async () => {
  //     try {
  //         setLoading(true);
  //         let apiUrl = `${GET_TASKS}?project_id=${projectId}`;

  //         const res = await getRequest(apiUrl, null, navigate);
  //         if (res.data && res.data.data) {
  //             const tasks = res.data.data;
  //             // setTaskList(tasks);
  //             setLoading(false);
  //             return tasks;
  //         } else {
  //             errorNotification(res.errormessage);
  //             // setTaskList([]);
  //         }
  //         setLoading(false);
  //         return [];
  //     }
  //     catch (error) {
  //         errorNotification(error);
  //         setLoading(false);
  //     }
  // };

  const getTaskList = async () => {
    // const fetchedTasks = await fetchTasks();
    const data = columnTitles?.reduce((acc, item) => {
      acc[item.index] = {
        title: item.title,
        id: item.id,
        items:
          taskList?.filter((task) => task?.task_status?.id === item?.id) || [],
      };
      return acc;
    }, {});
    setRows(data);
  };

  const updateTaskStatus = async (payload) => {
    setLoading(true);

    try {
      const res = await patchRequest(`${UPDATE_TASK}`, payload, navigate);
      if (res?.response && res?.response.data.success) {
        return true;
        // successNotification(res.response.data.message);
      } else {
        errorNotification(res?.errormessage);
      }
    } catch (error) {
      errorNotification(error);
    } finally {
      setLoading(false);
    }
  };

  const updateIndexOfTask = async (data) => {
    const payload = {
      project_id: projectId,
      tasks: data,
    };
    setLoading(true);
    try {
      const res = await patchRequest(
        `${UPDATE_PROJECT_TASKS_INDEX}`,
        payload,
        navigate
      );
      if (res?.response && res?.response.data.success) {
      } else {
        errorNotification(res?.errormessage);
      }
    } catch (error) {
      errorNotification(error);
    } finally {
      setLoading(false);
    }
  };

  const customIcons = {
    Low: <img src={low} alt="Low" style={{ width: "14px", height: "14px" }} />,
    Medium: (
      <img
        src={normal}
        alt="Medium"
        style={{ width: "14px", height: "14px" }}
      />
    ),
    High: (
      <img src={high} alt="High" style={{ width: "14px", height: "14px" }} />
    ),
  };

  const onDragEnd = async (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = rows[source.droppableId];
      const destColumn = rows[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      setRows({
        ...rows,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
      const updatedColumnsData = {
        ...rows,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      };

      const updatedTask = {
        task_id: removed.id.toString(),
        status_id: columnTitles?.filter(
          (task) => task?.title == rows[destination.droppableId].title
        )[0]?.id,
      };
      const res = await updateTaskStatus(updatedTask);
      if (res) {
        const transformedData = Object.keys(updatedColumnsData).map((key) => {
          const statusObj = updatedColumnsData[key];
          return {
            title: statusObj.title || statusObj.items[0]?.task_status?.title, // Use title or extract from items
            taskIds: statusObj.items.map((task) => task.id), // Create array of task IDs
          };
        });
        await updateIndexOfTask(transformedData);
        await getTasks();
      }
    } else {
      // Handle moving within the same column
      const column = rows[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setRows({
        ...rows,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
      const updatedColumnsData = {
        ...rows,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      };
      const transformedData = Object.keys(updatedColumnsData).map((key) => {
        const statusObj = updatedColumnsData[key];
        return {
          title: statusObj.title || statusObj.items[0]?.task_status?.title, // Use title or extract from items
          taskIds: statusObj.items.map((task) => task.id), // Create array of task IDs
        };
      });
      await updateIndexOfTask(transformedData);
      await getTasks();
    }
  };
  // Delete PopOver
  const [anchorPopOVer, setAnchorPopOVer] = useState(null);

  const handleClickPopOVer = (event) => {
    setAnchorPopOVer(event.currentTarget);
  };

  const handleClosePopOVer = () => {
    setAnchorPopOVer(null);
    setStatusDeleteId(null);
  };

  const openPopOverPopOVer = Boolean(anchorPopOVer);
  const PopOverIds = openPopOverPopOVer
    ? "simple-popover-add-delete"
    : undefined;

  const handleDrawerClose = () => {
    if(open){
      setOpen(false);
      setSelectedTaskId(null);
      getTasks();
    }
  };

  return (
    <div className="px-2 overflow-y-auto h-full">
      {rows === null || rows === undefined ? (
        <div className="no__transcation">
          <img src={noDataFound} alt={noDataFound} loading="lazy" />
        </div>
      ) : (
        <DragDropContext onDragEnd={onDragEnd}>
          <div className="flex flex-col min-h-[500px] gap-2">
            {/* Common Header */}
            <div
              className="w-full grid grid-cols-6 border-b-[#EFEFEF] font-medium p-2"
              ref={rowRef}
            >
              <div className="col-span-3">Task</div>
              <div className="col-span-1">Due Date</div>
              <div className="col-span-1 ">Assign to</div>
              <div className="col-span-1">Priority</div>
            </div>

            {Object.entries(rows).map(([columnId, column], index) => (
              <Droppable key={columnId} droppableId={columnId}>
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <div
                      className={`${
                        column?.title === "In Progress"
                          ? "text-[#db763b] bg-[#eeb08c3d] "
                          : column?.title === "Completed"
                          ? "text-[#83BF6E] bg-[#83bf6e24] "
                          : column?.title === "To be verified"
                          ? "text-[#8E59FF] bg-[#8e59ff1a] "
                          : "text-[#6F767E] bg-[#6f767e2b] "
                      } flex items-center justify-between mb-2 rounded    `}
                    >
                      {/* <div
                                                className={` mx-2 w-full overflow-x-auto my-2 rounded self-start ${column.items.length === 0 ? "mb-0" : ""
                                                    }`}
                                            > */}
                      <input
                        type="text"
                        placeholder="Enter title of task"
                        className={`focus:border border-[#cfcbcb] rounded-md px-2 py-1 bg-transparent`}
                        value={columnTitles[index]?.title}
                        style={{
                          fieldSizing: "content",
                          minWidth: "2em",
                          maxWidth: "100%",
                        }}
                        onChange={(e) => {
                          setColumnTitles([
                            ...columnTitles.slice(0, index),
                            { ...columnTitles[index], title: e.target.value },
                            ...columnTitles.slice(index + 1),
                          ]);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            e.target.blur();
                            handleTitleChange(columnTitles[index]);
                          }
                        }}
                        onBlur={() => {
                          handleTitleChange(columnTitles[index]);
                        }}
                        // readOnly={!role_access}
                      />
                      {/* </div> */}
                      <div className={` flex p-2 items-center`}>
                        <button
                          aria-describedby={PopOverIds}
                          variant="contained"
                          onClick={(e) => {
                            handleClickPopOVer(e);
                            setStatusDeleteId(column?.id);
                          }}
                          className="cursor-pointer"
                        >
                          <SlOptions />
                        </button>
                      </div>
                    </div>
                    <div className="w-full grid">
                      {column.items.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={String(item.id)}
                          index={index}
                        >
                          {(provided, snapshot) => {
                            const draggableStyle = {
                              ...provided.draggableProps.style,
                              width: rowRef.current
                                ? `${rowRef.current.offsetWidth}px`
                                : "auto", // Set width based on rowRef
                            };

                            return (
                              <div
                                ref={provided.innerRef}
                                className={`grid grid-cols-6 px-2 py-2.5 ${
                                  snapshot.isDragging ? "shadow-lg" : ""
                                } ${
                                  item?.member_removed == "true"
                                    ? "bg-[#f7f7f7]"
                                    : "bg-white"
                                } ${
                                  item?.is_completed
                                    ? "opacity-50"
                                    : "opacity-100"
                                } hover:!bg-[#f7f7f7] cursor-pointer border-b border-[#EFEFEF] `}
                                style={draggableStyle} // Apply draggable style
                                {...provided.draggableProps}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (window.getSelection().toString() === "") {
                                    // handleTaskView(item.id);
                                    handleDrawerOpen(
                                      item.id,
                                      item?.project?.id
                                    );
                                  }
                                }}
                              >
                                {/* Task */}
                                <div className="col-span-3 flex items-center gap-2 w-full pr-4">
                                  <div
                                    className="drag-handle cursor-grab mr-1"
                                    {...provided.dragHandleProps} // Drag handle only here
                                  >
                                    <GoGrabber />
                                  </div>
                                  <div
                                    className={`rounded-full border flex items-center ${
                                      !item?.is_completed
                                        ? "bg-white text-black"
                                        : "bg-green-600 text-white"
                                    } cursor-pointer`}
                                    onClick={async (e) => {
                                      e.stopPropagation();
                                      await handleTaskComplete(
                                        item.id,
                                        item?.is_completed
                                      );
                                      await getTasks();
                                    }}
                                  >
                                    <IoIosCheckmark />
                                  </div>
                                  <div className="truncate">{item.title}</div>
                                </div>

                                {/* Due Date */}
                                <div className="col-span-1 pr-4">
                                  {item?.due_date
                                    ? dayjs(item.due_date).format("DD-MM-YYYY")
                                    : "--"}
                                </div>

                                {/* Assign to */}
                                <div className="col-span-1 pr-4">
                                  {item?.assignee?.first_name ||
                                  item?.assignee?.last_name
                                    ? `${item.assignee.first_name} ${item.assignee.last_name}`
                                    : `${item?.assignee?.name || "--"}`}
                                </div>

                                {/* Priority */}
                                <div className="col-span-1">
                                  {item?.priority ? (
                                    <span className="flex flex-row gap-1 items-center">
                                      {customIcons[item?.priority]}{" "}
                                      {item?.priority}
                                    </span>
                                  ) : (
                                    "--"
                                  )}
                                </div>
                              </div>
                            );
                          }}
                        </Draggable>
                      ))}
                    </div>
                    {addingTaskToColumn === columnId ? (
                      <AddTaskListRow
                        projectId={projectId}
                        onCancel={() => setAddingTaskToColumn(null)}
                        getTasks={getTasks}
                        memberList={memberList}
                        columnTitles={columnTitles}
                        boardView={boardView}
                        columnId={column?.id}
                      />
                    ) : (
                      <>
                        {role_access && (
                          <button
                            className="px-3 py-1.5 text-sm font-medium text-white bg-[#267072] rounded hover:bg-[#267072] transition-colors mt-2 ms-2"
                            onClick={() => setAddingTaskToColumn(columnId)}
                          >
                            + Add Task
                          </button>
                        )}
                      </>
                    )}

                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            ))}
            {
              <div
                className={` text-[#6F767E] bg-[#6f767e2b] px-[10px] py-[2px] rounded self-start w-full `}
              >
                {/* {column.title} */}
                <input
                  type="text"
                  className={`focus:border border-[#cfcbcb] w-fit rounded-md px-1 "text-[#6F767E] bg-transparent`}
                  placeholder="+ Add Section"
                  value={newTitle}
                  onChange={(e) => {
                    setNewTitle(e.target.value);
                  }}
                  onKeyDown={async (e) => {
                    if (e.key === "Enter" && newTitle) {
                      await handleAddNewTitle(newTitle);
                      setNewTitle("");
                      await getTaskList();
                    }
                  }}
                  onBlur={async () => {
                    if (newTitle) {
                      await handleAddNewTitle(newTitle);
                      setNewTitle("");
                      await getTaskList();
                    }
                  }}
                  // readOnly={!role_access}
                />
              </div>
            }
          </div>
        </DragDropContext>
      )}

      <div>
        <Popover
          id={PopOverIds}
          open={openPopOverPopOVer}
          anchorEl={anchorPopOVer}
          onClose={handleClosePopOVer}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          PaperProps={{
            style: {
              borderRadius: "6px",
              marginTop: "8px",
              boxShadow:
                "0px 4px 6px -2px rgba(16, 24, 40, 0.08), 0px 12px 16px -4px rgba(0, 66, 86, 0.14)",
            },
          }}
        >
          <div className="w-[170px] min-w-[170px] py-2 bg-[#FFFFFF] shadow-[0_35px_60px_-15px_rgba(0,66,86,0.08)]">
            <div
              className="flex px-[14px] py-2 hover:bg-[#F8F8F8] cursor-pointer items-center"
              onClick={(e) => {
                handleClosePopOVer();
                deleteStatus(statusDeleteId);
              }}
            >
              <img
                src={deleteIcon}
                alt="delete"
                className="mr-[14px] h-4 w-4"
              />
              <p className="font-medium text-[#3C556B] text-[14px] align-middle">
                Delete
              </p>
            </div>
          </div>
        </Popover>
        <Box sx={{ display: "flex" }}>
          <ClickAwayListener onClickAway={handleDrawerClose}>
            <Drawer
              sx={{
                width: drawerWidth,
                flexShrink: 0,
                "& .MuiDrawer-paper": { width: drawerWidth },
              }}
              variant="persistent"
              anchor="right"
              open={open}
            >
              <DrawerTaskDetail
                onClose={handleDrawerClose}
                selectedTaskId={selectedTaskId}
              />
            </Drawer>
          </ClickAwayListener>
        </Box>
      </div>
    </div>
  );
};

export default TaskListView;
